import { render, staticRenderFns } from "./LoftRow.vue?vue&type=template&id=252cca94&scoped=true"
import script from "./LoftRow.vue?vue&type=script&lang=js"
export * from "./LoftRow.vue?vue&type=script&lang=js"
import style0 from "./LoftRow.vue?vue&type=style&index=0&id=252cca94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cca94",
  null
  
)

export default component.exports